import { Link } from 'react-router-dom';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#FAF8F5] border-t border-[#E8E4DF]" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-8 lg:gap-12">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 bg-[#1A1411] rounded flex items-center justify-center">
                <span className="text-white font-bold text-sm">Q1</span>
              </div>
              <span className="font-medium text-[#1A1411]">QIndex One</span>
            </Link>
            <p className="text-[#6B5B52] text-sm leading-relaxed">
              Client Intelligence Platform for Family Offices & Advice Firms
            </p>
          </div>

          {/* Product Links */}
          <div>
            <h4 className="text-[#1A1411] font-medium text-sm mb-4">Product</h4>
            <ul className="space-y-3">
              <li>
                <a href="/#product" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Features
                </a>
              </li>
              <li>
                <a href="/#how-it-works" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  How it works
                </a>
              </li>
              <li>
                <a href="/#pricing" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* Capabilities Links */}
          <div>
            <h4 className="text-[#1A1411] font-medium text-sm mb-4">Capabilities</h4>
            <ul className="space-y-3">
              <li><a href="/#product" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">Client 360</a></li>
              <li><a href="/#product" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">Lead Pipeline</a></li>
              <li><a href="/#product" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">AI Insights</a></li>
              <li><a href="/#product" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">Analytics</a></li>
            </ul>
          </div>

          {/* Get Started Links */}
          <div>
            <h4 className="text-[#1A1411] font-medium text-sm mb-4">Get started</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/pilot" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Start a pilot
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Book walkthrough
                </Link>
              </li>
              <li>
                <Link to="/login" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Login
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h4 className="text-[#1A1411] font-medium text-sm mb-4">Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/security" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Security & Compliance
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/security" className="text-[#6B5B52] hover:text-[#A86A3A] text-sm transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-[#E8E4DF] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#9B8B7E] text-sm">
            © {currentYear} QIndex One. All rights reserved.
          </p>
          <p className="text-[#9B8B7E] text-sm">
            <a href="mailto:contact@qindexone.com" className="hover:text-[#A86A3A] transition-colors">
              contact@qindexone.com
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
